"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoJSHelper = exports.vendor = void 0;
var crypto_js_1 = require("crypto-js");
var Session_helper_1 = require("./Session.helper");
/** Keys */
exports.vendor = {
    comp: "I4982898H_DDD3313*èAùùRFFa3H5%&£",
    dist: "A73/Ki2rrfo/GNTi8AN+PaP",
    jar: "*_V^XcD,L$$)2,T`TpWLznk@.D:M6ZYk",
    var: "JTH74Iieh2=945dLp0?(jw921j4j53jk",
    calc: "V}Nc3$346w+SZ$KY&Cc7~uv%>a(%V{^M",
    merge: "7n?gS;vLDw$Q@[{7VUw87RFFa3[Apx%",
    size: "U78/Kiqdwaf425NTi8{AN+PaB2A3P",
    dust: ":V@E}>eL+HA:_Dz+k=Pr.8R]9nT]8tnw",
    core: "U78/Kiqdo/GNTi8{AN+PaB2A3P",
    link: "FKFUE83IR+RRRIUE54*P43(+HE",
};
exports.CryptoJSHelper = {
    encrypt: function (key, data) { return __awaiter(void 0, void 0, void 0, function () {
        var aes;
        return __generator(this, function (_a) {
            aes = crypto_js_1.AES.encrypt(data, exports.vendor.var);
            return [2 /*return*/, Session_helper_1.SessionHelper.setData(key, aes.toString())];
        });
    }); },
    decrypt: function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var encryptedValue, decryptedWordArray, decryptedValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Session_helper_1.SessionHelper.getData(key)];
                case 1:
                    encryptedValue = _a.sent();
                    if (!encryptedValue)
                        return [2 /*return*/, null];
                    decryptedWordArray = crypto_js_1.AES.decrypt(encryptedValue.toString(), exports.vendor.var);
                    decryptedValue = decryptedWordArray.toString(crypto_js_1.enc.Utf8);
                    return [2 /*return*/, decryptedValue];
            }
        });
    }); },
    encryptSingleData: function (data) {
        var aes = crypto_js_1.AES.encrypt(data, exports.vendor.var);
        return aes;
    },
    decryptSingleData: function (data) {
        var decrypted = crypto_js_1.AES.decrypt(data, exports.vendor.var);
        return decrypted;
    },
};
